import { t as tr } from '../i18n.js'
import { Link, useParams } from 'react-router'
import { ProjectTabs } from './ProjectTabs.js'
import { atLeast, useAuth } from '../auth.js'
import { useProjectSource } from './taskSource.js'
import { GanttView } from './GanttView.js'

/** Gantt page: the single-project wrapper around GanttView (crumbs + tabs + the project task source). */
export function GanttPage() {
  const { projectId = '' } = useParams()
  const { user } = useAuth()
  const src = useProjectSource(projectId)
  const p = src.projects[0]

  if (src.status === 'error') return <p className="bad">{tr("Project not found, or you do not have access.")} <Link to="/projects">{tr("Back to projects")}</Link></p>
  if (src.status === 'pending' || !p) return <p className="muted">{tr("Loading…")}</p>

  return <GanttView source={src} header={<>
    <p className="crumbs"><Link to="/projects">{tr("Projects")}</Link> / {p.code}</p>
    <ProjectTabs projectId={p.id} active="gantt" canApprove={p.canManageMembers} canSeeRates={atLeast(user, 'manager')} />
  </>} />
}
